const en = {
	translation: {
		errors: {
			emptySingleField: "Field cannot be left empty",
			emptyUserName: "The login field cannot be left empty.",
			passwordToShort: "Minimum password length is 8 characters",
			wrongPasswordOrLogin: "Wrong login or password",
			emptyField: "All fields must be filled in",
			passwordsNotTheSame: "The passwords you entered don't match",
			wrongEmailFormat: "Please enter a valid email address format",
			usernameExists: "This username is already taken",
			emailExists: "This email is already taken",
			requiredField: "This field is required",
			somethingWentWrong: "Something went wrong, please try again later.",
			maxCountOfQuestions:
				"The maximum number of questions in one exam is: {{count}}",
			emptyWrongAnswersInCourse:
				"There are no missolved questions in this course.",
			cannotGetExam:
				"There was an issue with downloading the exam. Please try again later. If the problem persists, please contact our team.",
			toManyQuestionsInExamCourse:
				"The maximum number of questions in one exam is: {{maxQuestions}}. Use the 'Generate course from wrong answers' option.",
			emptyFieldText: "All fields must be filled in",
			emptyFlashcards:
				"Fill in the front and back of the flashcard to add it to the set",
			passwordsNotTheSameText: "The passwords you entered don't match",
			wrongOldPassword: "The old password you entered is incorrect",
			sessionHasExpired: "Your session has expired. Log back in to the site.",
			editPrivateFlashcards:
				"This flashcard is from a different set. It can't be edited.",
			emptyDeck: "There are no flashcards in this set",
			flashcardExist: "This flashcard already exists in the selected set",
			emptyName: "Fill the name and then try again",
			errorBoundary: {
				header: "Oops! Something has gone wrong here.",
				subheader:
					"Our brainiacs are on their way to fix this! Please try again in a moment. If the problem persists, please contact us!",
				buttonText: "Return to page",
			},
			emptyItems:
				"No questions were found for the specified parameters. Please change the query parameters and try again.",
			emptyComment: "Comment can't be empty",
			addCommentProblem: "Something went wrong, please try again later.",
			tooManyRequests: "Too many requests, please try again later.",
			tooManyLessons:
				"Not enough questions per day to generate a course. Change the configuration and try again",
			wrongPromocode: "Promotional code does not exist",
			maxSourceLength: "Maximum length of source field is {{maxLength}}",
			emptyPromocode: "",
			commentNotFound: "Unfortunately, the comment has been deleted",
			uploadImageProblem:
				"There was a problem uploading the file. Make sure the file size and format are appropriate.",
			messageToShort: "Minimum message length is {{minLength}} characters",
		},
		success: {
			commentAdded: "Comment added successfully.",
			commentWaiting: "Your comment is awaiting approval from our team.",
		},
		shortcuts: {
			prevQuestion: "Previous question",
			nextQuestion: "Next question",
			answerA: "Answer a",
			answerB: "Answer b",
			answerC: "Answer c",
			answerD: "Answer d",
			answerE: "Answer e",
			article: "Open/close article",
			discussion: "Open/close discussion",
			favorite: "Add/remove from favorites",
			comments: "Open/close comments",
		},
		tooltips: {
			showAllExams: "View all exams",
			showAllCourses: "View all courses",
			showAllDecks: "View all decks",
			createNewExam: "Create new exam",
			createNewDeck: "Create new deck",
			createNewCourse: "Create new course",
			removeComment: "Delete comment",
			removeQuestion: "Delete question",
			replyComment: "Reply to comment",
			likeComment: "Like comment",
			dislikeComment: "Remove like",
			sortComments: "Sort",
			filterComments: "Filters",
			settings: "Dashboard settings",
			notifications: "Notifications",
			profile: "User profile",
			admin: "Moderator from our team",
			watchQuestion: "Watch question",
			basicExamType: "Standard Exam",
			simulationWithoutTimer: "Exam Simulation without Timer",
			simulationWithTimer: "Exam Simulation with Timer",
			excludedAnswer: "Exclude answer",
		},
		defaultsText: {
			emptyName: "No name",
			logout: "Log out",
			yoursScore: "Your score",
			score: "Score",
			finished: "Finished",
			showAll: "See all",
			filter: "Filters",
			found: "Found",
			minimize: "Minimize",
			expand: "Expand filters",
			actions: "Actions",
			title: "It's a bit empty here...",
			emptyRows: "It's a bit empty here...",
			emptyCommentsList: "No recently commented questions found",
			emptyUsersQuestionList: "No user questions found",
		},
		commands: {
			send: "Send",
			create: "Create",
			browse: "Browse",
			resolve: "Solve",
			remove: "Delete",
			cancel: "Cancel",
			skip: "Skip",
			save: "Save",
			refresh: "Refresh",
			edit: "Edit",
			back: "Go back",
			close: "Close",
			add: "Add",
			reorder: "Change order",
			prev: "Previous",
			next: "Next",
			mark: "Check",
			unmark: "Uncheck",
			start: "Start",
			blocked: "Blocked",
			resume: "Resume",
			watch: "Watch",
			search: "Search",
			clear: "Clear",
			added: "Added",
			more: "More",
			loading: "Loading...",
			saved: "Saved",
			use: "Use",
			all: "All",
			addAttachment: "Add attachment",
			nextQuestion: "Next question",
			prevQuestion: "Preview question",
			addFlashcard: "Add to deck",
			saveChanges: "Save changes",
			seeMore: "See more",
			collapse: "Collapse",
			expand: "Expand",
			news: " New!",
			confirm: "Confirm",
			import: "Import",
		},
		csvImport: {
			frontShort: "Front",
			backShort: "Back",
			optional: "optional",
			skip: "(skip)",
			title: "Import CSV / XLSX",
			description:
				"Select columns from the file that correspond to the front and back of the flashcard",
			front: "Front of flashcard",
			back: "Back of flashcard",
			count: "Number of flashcards: {{count}}",
			hasHeader: "First row contains headers",
			deckName: "Set name",
			deckDescription: "Set description",
		},
		flashcardsImport: {
			title: "Import flashcards",
			dropzone: {
				drop: "Drag a file here or",
				pick: "choose from disk",
			},
			pickFile: "Choose a file",
			pickFileHint:
				"For CSV and XLSX you'll match the columns. Anki and TXT are imported right away.",
			fileSelected: "File selected",
			changeFile: "Change file",
			unsupported: "Unsupported file format",
			tooFewColumns: "The file must have at least 2 columns",
			error: "Failed to read the file",
			rows_one: "{{count}} row",
			rows_other: "{{count}} rows",
			ankiReady_one:
				"The Anki file already has flashcard sides – nothing to match. Found {{count}} flashcard.",
			ankiReady_other:
				"The Anki file already has flashcard sides – nothing to match. Found {{count}} flashcards.",
			mapColumns: "Match columns",
			mapColumnsHint:
				"Choose the columns with the front and back of the flashcard.",
			preview: {
				title: "Check the preview",
				hint: "This is how the imported flashcards will look.",
				more_one: "… and {{count}} more row",
				more_other: "… and {{count}} more rows",
			},
			steps: {
				file: "File",
				columns: "Columns",
				preview: "Preview",
			},
			next: "Next",
			fileReady: "File ready. Continue to match the columns.",
			fileReadyAnki: "File ready. Continue to see the preview.",
			mapColumnsHintDecks:
				"Choose the columns with the front and back of the flashcard. Set name and description are optional.",
			column: "col. {{letter}}",
			field: "field {{n}}",
			importCount_one: "Import {{count}} flashcard",
			importCount_other: "Import {{count}} flashcards",
			anki: {
				noCards: "No flashcards found in the file",
				parsing: "Loading sets...",
				foundDecks: "Found sets",
			},
			page: {
				title: "Import flashcard sets",
				faq: "FAQ",
				importedCount: "Imported sets",
				emptyTitle: "You don't have any sets added yet",
				emptySubtitle:
					"Use the button below to upload flashcard sets. Added files will appear here",
				createDecks: "Create sets",
				defaultDeckName: "New set",
				success: "Sets have been created",
				error: "Failed to create sets",
				maxDecks_one: "You can create up to {{count}} set at once",
				maxDecks_other: "You can create up to {{count}} sets at once",
				partialError_one: "Created {{count}} set, the rest failed — try again",
				partialError_other:
					"Created {{count}} sets, the rest failed — try again",
				deckTooLarge:
					"Set “{{name}}” is too large — split it into smaller sets",
			},
		},
		globalSearch: {
			placeholder: "Search questions, articles, flashcards…",
			clear: "Clear",
			loadMore: "Load more ({{shown}} of {{total}})",
			empty:
				"No results for “{{phrase}}”. Try a shorter phrase or turn off filters.",
			showOnly: "Show only:",
			ownDeck: "Your deck",
			companyDeck: "Official deck",
			tabs: {
				all: "All",
				questions: "Questions",
				articles: "Articles",
				decks: "Flashcards",
			},
			filters: {
				starred: "Starred",
				wrongAnswers: "Answered wrong",
				isUnanswered: "Unanswered",
			},
			sections: {
				questions: "Questions",
				articles: "Articles",
				decks: "Flashcard decks",
			},
			showAll: {
				questions: "All questions",
				articles: "All articles",
				decks: "All decks",
			},
			snippetSource: {
				title: "in title",
				question: "in question",
				answer: "in answer {{letter}}",
				content: "in content",
				description: "in explanation",
				flashcardFront: "in flashcard · front",
				flashcardBack: "in flashcard · back",
			},
			keys: {
				navigate: "navigate",
				open: "open",
				close: "close",
			},
			questions: "Search by question content...",
			articles: "Search by article title...",
			decks: "Search by deck name...",
		},
		units: {
			questions: "questions",
			lessons: "lessons",
			day: "day",
			flashcards: "flashcards",
			decks: "decks",
		},
		datePicker: {
			selectDate: "Select date",
			selectRangeTitle: "Select date range (max {{maxDays}} days)",
			selectRangeTitleNoMax: "Select date range",
			cancel: "Cancel",
			confirm: "View",
			set: "Set",
		},
		auth: {
			services: {
				selectService: "Select Service",
				signInToService: "Log into {{serviceName}}",
				title: "Your space for effective studying for the LEK exam.",
				titleLDEK: "Your space for effective studying for the LDEK exam.",
				description:
					"Study comfortably for {{services}} in the {{serviceName}} platform",
				pes: {
					name: "PES",
					description:
						"State Specialization Exam (Państwowy Egzamin Specjalizacyjny)",
				},
				back: "Back to the homepage",
				lek: {
					name: "LEK",
					description: "Medical Final Examination (Lekarski Egzamin Końcowy)",
				},
				info: {
					examsLdek: "All LDEK exams with correct answers",
					exams: "All LEK exams with correct answers",
					articles: "Medical infographics",
					flashcards: "Flashcards to help memorize content",
				},
			},
			signIn: "Log in",
			signingIn: "Logging...",
			createAccount: "Create account",
			signUp: "Sign up",
			signUpQuestion: "Don't have an account?",
			signInQuestion: "Already have an account?",
			forgotPassword: "Forgot your password?",
			form: {
				password: "Password",
				login: "Username",
				email: "E-mail address",
				passwordRepeat: "Repeat password",
				oldPassword: "Old password",
				newPassword: "New Password",
			},
			alerts: {
				accountCreated:
					"A <0>{{email}}</0> account has been successfully created on the website",
				passwordChanged:
					"You have successfully changed your account password. Use your new data to log in.",
			},
			resetPassword: {
				emailSent: {
					title: "Check your email",
					subtitle: "We've sent a password reset link to your email.",
					backToLogin: "Go back to login",
				},
				form: {
					title: "Forgot your password?",
					subtitle:
						"No worries! Enter your email address and we'll send you a password reset link.",
					email: "Enter your email",
					sending: "We're sending you an email...",
				},
				setPassword: {
					subtitle: "Set a new safe password for your account.",
					submit: "Set a new password",
					title: "Set a new password",
				},
				linkUsed: {
					title: "The link has already been used",
					subtitle:
						"Sorry this link was used before, please try resetting your password again.",
					submit: "Reset again",
				},
			},
		},
		navbar: {
			flashcards: "Flashcards",
			courses: "Courses",
			exams: "Exams",
			articles: "Knowledge Base",
			home: "Start Page",
			homeMobile: "Start",
			folders: "Folders",
			yourFolders: "Your folders",
			addFolder: "Add new folder",
			more: "More",
			guide: "Guide",
		},
		guide: {
			navigation: {
				previous: "Previous section",
			},
			addBlock: "Add block",
			globalWarning:
				"You are editing the guide shared by all specialisations — users of every PES specialisation will see these changes.",
			form: {
				name: "Section name",
				nameMaxLength: "Maximum 255 characters",
				isGlobal: "Section shared by all specialisations",
			},
			empty: "The guide is being prepared.",
			banner: {
				title: "Not sure where to start studying?",
				subtitle:
					"Check our guide and prepare for the exam following a proven plan",
				action: "See the guide",
			},
		},
		contentPicker: {
			examType: {
				title: "Choose Exam Type",
				basic: {
					title: "Standard",
					subtitle:
						"Create your new exam based on freely selected parameters such as: number of sessions, sections, starred questions, and incorrectly answered questions.",
					submit: "Create Standard Exam",
				},
				simulation: {
					title: "Test Simulation",
					subtitle:
						"Create an exam and simulate real test conditions. In this configuration, you can edit answers, measure time, and you will only learn the correctness of your answers after the test is completed.",
					submit: "Create Test Simulation",
				},
			},
			courseType: {
				title: "Choose Course Type",
				searchPlaceholder: "Search course",
				emptyText: "No course found for the given parameters",
				emptyTemplates:
					"We are working on preparing the courses. Check back soon :)",
				basic: {
					title: "Standard",
					subtitle:
						"Create your new course based on freely selected parameters such as: number of sessions, sections, starred questions, and incorrectly answered questions.",
					submit: "Create Standard Course",
				},
				templates: {
					title: "Choose a template course",
					subtitle:
						"Use courses prepared by our team and prepare for the exam.",
					submit: "Choose course",
				},
			},
			exam: {
				title: "Exams",
				create: {
					title: "Create a new exam",
					subtitle:
						"Create your new exam based on any parameters, such as the number of sessions, sections, questions marked with an asterisk and incorrectly solved questions.",
				},
				list: {
					title: "Your exams",
					subtitle:
						"Continue Your Unfinished Exams or View Completed Exams. Generate exams from favourites questions or incorrect answers from any number of selected exams.",
				},
			},
			flashcards: {
				title: "Flashcards",
				create: {
					title: "Create a new set",
					subtitle:
						"Create your new set of flashcards from scratch or based on publicly available sets. Your set can be private or public.",
				},
				list: {
					title: "Your Sets",
					subtitle:
						"Browse your sets and revise flashcards based on a spaced repetition algorithm that will make it easier for you to remember them.",
				},
				createOwn: {
					title: "Create your own set",
					subtitle:
						"Create your new set of flashcards. Your set can be private or public.",
					submit: "Create set",
				},
				browseExisting: {
					title: "Choose from existing sets",
					subtitle:
						"Choose a set from a wide list and learn from prepared and verified content",
					submit: "Create set",
				},
				importMany: {
					title: "Import multiple sets",
					subtitle:
						"Create multiple flashcard sets at once by importing csv, txt or Anki files",
				},
			},
			flashcardsMode: {
				spacedRepetition: {
					title: "Spaced repetition",
				},
				knowDontKnow: {
					title: "Know/don't know",
				},
			},
			courses: {
				title: "Courses",
				create: {
					title: "Create a new course",
					subtitle:
						"Create your new course based on any parameters, such as the number of sessions, sections, thematic categories, number of questions/day and course duration.",
				},
				list: {
					title: "Your Courses",
					subtitle: "Browse Your Courses and Continue Learning.",
				},
			},
		},
		filters: {
			popper: {
				selectFilter: "Select Filter",
			},
			viewType: {
				select: "Select view type",
				list: "List",
				carusel: "Carousel",
			},
			exams: {
				timer: {
					title: "Timer",
					examTime: "Exam duration:",
					timePerQuestion: "Time to answer the question: ",
					timeHint: "In a standard exam, the time per question is 1 minute",
				},
				typeOfExam: {
					title: "Database question type",
					lek: {
						hint: "Select a question base from which you will generate the exam. Leave this field blank if you want to generate an exam containing questions from both the CEM question database and past LEK questions.",
						cem: {
							title: "CEM Question Database",
							hint: "Questions from the CEM question database (70% of the exam questions are taken from the database)",
						},
						all: {
							title: "Archival Questions",
							hint: "Questions from LEK since 2008 that are not part of the CEM question database",
						},
					},
					pes: {
						hint: "Select the question base from which you will generate the exam. Leave this field blank if you want to generate an exam that contains questions from both the official CEM questions and the recreated questions.",
						cem: {
							title: "The official Questions",
							hint: "The official PES questions published by CEM",
						},
						all: {
							title: "Recreated Questions",
							hint: "PES questions recreated by the EgzaminLEK Team",
						},
					},
				},
				departments: {
					title: "Select Departments",
					search: "Search...",
					lekHint:
						"You can narrow down the subject matter of the exam to specific sections.",
					pesHint:
						"You can narrow down the subject matter of the exam to specific sections of {{specialisation}}.",
				},
				terms: {
					title: "Select session dates",
				},
				additional: {
					title: "Additional Options",
					starred: "Favourites Questions",
					wrongAnswers: "Incorrectly solved questions",
					skipCanceledQuestions: "Skip canceled questions",
					questionWithNote: "Questions with note",
					unanswered: "Select only unanswered questions",
					countOfQuestions:
						"How many questions do you want the exam to include?",
					hint: "Questions will be randomly selected from the options you have chosen",
					generateRandomExam: "Generate random exam",
				},
				cemVersions: {
					title: "Version of the published CEM database",
					hint: "You can narrow down the number of questions to a given version of the CEM database",
				},
				unansweredComments: {
					title: "Comments",
					label: "Without replies",
				},
				aiDiscussions: {
					title: "AI Discussions",
					isAiUnapproved: "Questions without approved AI discussion",
					hasUnresolvedReviews: "Questions with unresolved reviews",
					refresh: "Refresh question list",
				},
				specialisations: {
					title: "Specializations",
				},
				level: {
					title: "Question difficulty level",
					filterHint:
						"Difficulty level determined based on our users’ responses",
					hint: {
						title: "Our users responses",
						correctAnswers: "Incorrect answers",
						wrongAnswers: "Correct answers",
					},
					levels: {
						hard: "Hard",
						medium: "Medium",
						easy: "Easy",
					},
				},
			},
			courses: {
				date: {
					endDate: "Estimated End Date:",
				},
			},
			decks: {
				permission: {
					title: "Set availability",
					public: "Public",
					private: "Private",
					publicDescription:
						"Anyone can view the deck and learn from it. Only you can edit it.",
					privateDescription: "Only you can see the deck and learn from it.",
				},
				tags: {
					title: "Tags",
				},
			},
		},
		creators: {
			selectFolders: "Add to folders",
			foldersSelected: "Folders ({{count}})",
			foldersSelectedLabel: "Folders:",
			exams: {
				title: "Create a new exam",
				inputPlaceholder: "Enter an exam name",
				counterText: "Number of questions",
				creating: "I'm creating an exam...",
				examName: "Exam name",
				hint: "Help",
				removeFilters: "Remove filters",
				helpCenter: "Click to discover another options from our creator",
			},
			courses: {
				title: "Create a new course",
				inputPlaceholder: "Enter a name for the course",
				counterText: "The number of questions",
				creating: "I'm creating an exam...",
				removeFilters: "Remove filters",
				countOfQuestionsPerDay:
					"How many questions do you want to solve per day?",
				day: "day",
				tip: "In our experience, you need to spend about 2 minutes on each question",
			},
			decks: {
				decksNotFound: "The set not found",
				noDescription: "No description for the set",
				flashcardsInDeck: "Flashcards in this set",
				title: "Create a new set of flashcards",
				deckName: "Set name",
				inputPlaceholder: "Name your set",
				counterText: "Number of flashcards in the set",
				creating: "I'm creating a set",
				uploadingImages: "Uploading images...",
				draftModal: {
					title: "You have an unsaved set",
					description_one:
						"We found a draft of your set (<b>{{count}} flashcard</b>). Do you want to restore it or start over?",
					description_other:
						"We found a draft of your set (<b>{{count}} flashcards</b>). Do you want to restore it or start over?",
					restore: "Restore",
					discard: "Start over",
				},
				addFlashcard: "Add a flashcard",
				addToDeck: "Add flashcard to set",
				addOwnFlashcard: "Add your own flashcard to the set",
				importDecks: "Import sets",
				createDeck: "Create set",
				descriptionToggle: "Set description (optional)",
				descriptionPlaceholder: "Describe your set",
				errors: {
					emptyDeck: "Unable to create a set without flashcards.",
					nameRequired: "To create a set, fill in the field with the name",
					saveError: "Failed to save the set",
				},
			},
		},
		foldersList: {
			search: "Search folder",
			title: "Folders",
			newFolder: "New folder",
			sort: {
				updatedAt: "Last updated",
				createdAt: "Created date",
				alphabetical: "Alphabetically",
				asc: "Ascending",
				desc: "Descending",
			},
		},
		folder: {
			movedToFolderSuccess: "Moved to folder",
			copiedToFolderSuccess: "Copied to folder",
			removedFromFolderSuccess: "Removed from folder",
			addToFolder: "Add to folder",
			editFolder: "Edit folder",
			selectMany: "Select multiple",
			deleteFolder: "Delete folder",
			removeFromFolderTitle: "Remove from folder",
			showAll: "Show all",
			loading: "Loading...",
			loadMore: "Load more",
			showing: "Showing:",
			showingCountValues: "{{loaded}} of {{total}} items",
			selectedElements: "Selected elements",
			move: "Move",
			copy: "Copy",
			removeFromFolder: "Remove",
			search: "Search",
			selectedCount: "Selected: {{count}}",
			moveToFolder: "Move to folder",
			moveToFolderTitle: "Move to folder",
			copyToFolder: "Copy to folder",
			copyToFolderTitle: "Copy to folder",
			movingLabel: "Moving:",
			copyingLabel: "Copying:",
			itemsCount_one: "{{count}} item",
			itemsCount_other: "{{count}} items",
			searchFolder: "Search folder",
			targetFolders: "To folder: <0>{{names}}</0>",
			selectedFolders: "Selected: <0>{{names}}</0>",
			chooseFolders: "Choose folders from the list",
			selectContentToFolder: "Select content for folder {{folderName}}",
			newExam: "New exam",
			newCourse: "New course",
			newDeck: "New set",
			newNote: "New note",
			tabs: {
				all: "All",
				flashcards: "Flashcards",
				exams: "Exams",
				courses: "Courses",
				notes: "Notes",
			},
			searchResultsFor: 'Results for "{{query}}"',
			noSearchResults: "No search results",
			noCourses: "You don't have any courses yet",
			noExams: "You don't have any exams yet",
			noDecks: "You don't have any flashcard sets yet",
			noNotes: "You don't have any notes yet",
			createCourse: "Create course",
			createExam: "Create exam",
			createDeck: "Create flashcard set",
			createNote: "Create note",
			addNext: "Add next",
			emptyList: {
				title: "Something's missing here...",
				description: "Add items to the folder and they will appear here",
				button: "Add items",
			},
		},
		editor: {
			placeholder: "Start writing...",
			saveError: "Failed to save",
			uploadError: "Failed to add the image",
			uploading: "Saving...",
			table: {
				title: "Table",
				insert: "Insert table",
				addColumnAfter: "Add column",
				deleteColumn: "Delete column",
				addRowAfter: "Add row",
				deleteRow: "Delete row",
				toggleHeaderRow: "Toggle header row",
				deleteTable: "Delete table",
				addTitle: "Add table title",
				removeTitle: "Remove table title",
				addNote: "Add legend",
				removeNote: "Remove legend",
				titlePlaceholder: "Table title",
				notePlaceholder: "Legend, e.g. * explanation",
			},
		},
		note: {
			untitled: "Untitled note",
			titleLabel: "Note name",
			save: "Save changes",
			cancel: "Cancel",
			emptyContent: "Note content cannot be empty",
			saveError: "Failed to save the note",
			saveSuccess: "Note has been saved",
		},
		validation: {
			required: "This field is required",
			maxChars: "Maximum 255 characters",
		},
		menuActions: {
			emptyActions: "No possible actions",
			folder: {
				folders: "Folders",
				moveToFolder: "Move to another folder",
				copyToFolder: "Copy to folder",
				removeFromFolder: "Remove from folder",
			},
			course: {
				resume: "Resume course",
				generateExamFromWrongAnswers: "Generate exam from wrong answers",
				generateCourseFromWrongAnswers: "Generate course from wrong answers",
				remove: "Delete course",
				edit: "Edit Course",
				sections: "Sections",
				copyCourse: "Retake course",
				moveToFolder: "Move to folder",
			},
			courseSection: {
				statistics: "Statistics",
			},
			flashcards: {
				resolve: "Solve set",
				resolveAgain: "Solve again",
				show: "View the set",
				share: "Share Set",
				edit: "Edit Set",
				preview: "Preview Set",
				remove: "Delete Set",
				useDeck: "Study from this set",
				moveToFolder: "Move to folder",
				allFlashcards: "All flashcards",
				addFlashcard: "Add flashcard",
				statistics: "Statistics",
				copy: "Copy set",
				copying: "Copying set…",
			},
			exams: {
				statistics: "Statistics",
				resume: "Resume exam",
				changeName: "Rename",
				remove: "Delete exam",
				watch: "View Exam",
				generateExamFromWrongAnswers: "Generate exam from wrong answers",
				generateFromStarredQuestions: "Generate exam from favourites questions",
				copyExam: "Regenerate Exam",
				moveToFolder: "Move to folder",
			},
			lessons: {
				generateExamFromWrongAnswers: "Generate exam from wrong answers",
				editNote: "Edit note",
				deleteNote: "Delete note",
				addNote: "Add note",
			},
			section: {
				resolveAgain: "Resolve section again",
				reportImprovement: "What can we improve in this section?",
				remainingLessons: "Remaining <0>{{left}}</0> out of <0>{{all}}</0>",
			},
		},
		defaultNames: {
			wrongAnswers: "Incorrectly answered",
			starred: "Favourites",
			commands: {
				cemDatabase: "CEM Question Database",
				allQuestions: "All questions CEM",
				categories: "Categories",
				all: "all",
				tags: "Tags",
				subtags: "Subtags",
				terms: "Terms",
				starred: "Favourites",
				wrongAnswers: "Incorrectly answered",
			},
		},
		modals: {
			guide: {
				confirmDeleteSection:
					"Are you sure you want to delete this chapter together with all its content?",
			},
			createFolder: {
				title: "Create a new folder",
				name: "Folder name",
				submit: "Create folder",
				maxLengthError: "Folder name cannot exceed 255 characters",
				colorLabel: "Folder color",
			},
			editFolder: {
				title: "Edit folder",
			},
			selectFolders: {
				title: "Select folders",
				confirm: "Select",
			},
			statistics: {
				title: "Statistics",
				failTitle: "You didn't make it this time",
				successTitle: "Congratulations!",
				timeOver: "The time to complete the exam has run out. ",
				successSubtitle:
					"You passed the exam. Below you will find the statistics for this attempt.",
				failSubtitle:
					"You did not pass the exam. Below you will find the statistics for this attempt.",
				correctAnswers: "Correct answers",
				wrongAnswers: "Wrong answers",
				skippedAnswers: "Skipped questions",
				cancelledAnswers: "Cancelled questions",
				goToCourse: "Go to course",
				yourScore: "Your score: ",
				scoreLabel: "Your score",
				passed: "Passed",
				failed: "Failed",
				goToHome: "Go to home page",
				answers: "Answers",
				examInfo: "Exam data",
				currentScore: "Current score",
				categoriesTitle: "Results by category",
				correctCount_one: "{{count}} correct",
				correctCount_other: "{{count}} correct",
				wrongCount_one: "{{count}} wrong",
				wrongCount_other: "{{count}} wrong",
				questionsCount: "Number of questions",
				sectionInfo: "Section",
				tabs: {
					examInfo: "Exam Data",
					sectionInfo: "Statistics",
					stats: "Statistics",
					sectionStats: "Statistics per section",
				},
				tooltips: {
					blocked: "Statistics will be unlocked after completing the exam",
					stats: "Exam statistics",
				},
				empty: {
					title: "No data found",
					description:
						"No answers were provided in this period. Change the search results to see your statistics",
				},
			},
			deckStatistics: {
				title: "Set has been solved",
				subtitle:
					"All flashcards have already been reviewed today. Come back tomorrow and continue learning.",
				statsHeader: "Statistics",
				flashcardsCount: "Flashcards count",
				cardsCount_one: "{{count}} flashcard",
				cardsCount_other: "{{count}} flashcards",
				sortLabel: "Sort:",
				showOtherDecks: "See other",
				keepLearning: "Keep learning",
				resolveAgain: "Solve again",
				tabs: {
					stats: "Statistics",
					flashcards: "Flashcards",
				},
				statsType: {
					knowDontKnow: "Know / don't know",
					spacedRepetition: "Spaced repetition",
				},
				flashcardsSort: {
					updatedAt: "Updated date",
					bestKnown: "Best known",
					worstKnown: "Worst known",
					mostAnswered: "Most answered",
					leastAnswered: "Least answered",
				},
			},
			settings: {
				title: "Settings",
				fontSizeTitle: "Font size",
				darkMode: "Dark mode",
				shortcuts: "Shortcuts",
				survey: "Satisfaction survey",
				swipeable: "Gestures",
			},
			copyForbidden: {
				title: "Copying content is forbidden",
				subtitle:
					"Due to the behavior of our competitors who copy our hard work without hesitation, we have been forced to disable the ability to copy content on our site. We apologize and thank you for your understanding.",
				confirm: "Ok",
				customCopyText:
					"Please respect our hard work and stop copying our content. Thank you!",
			},
			appInformation: {
				yoursVersion: "Your version of the app",
				availableVersion: "Available version of the application",
				noInformation: "No information about the application",
			},
			confirm: {
				regenerateCourseSection: {
					title: "Are you sure you want to re-do this section?",
					subtitle:
						"All data from this section will be deleted, and you will have to complete the lessons again.",
				},
				regenerateDiscussion: {
					title: "Are you sure you want to regenerate this discussion?",
					subtitle:
						"The current discussion will be permanently deleted and a brand new one will be generated from scratch. This action cannot be undone.",
				},
				deleteLessonNote: {
					title: "Are you sure you want to delete this note?",
					subtitle:
						"This action cannot be undone; the note will be permanently deleted.",
				},
			},
			changeName: {
				changed: "Changed",
				previous: "Previously:",
				restore: "Restore",
				empty: "Name cannot be empty.",
				exam: {
					title: "Rename exam",
					label: "Exam name",
					placeholder: "Enter exam name",
				},
				course: {
					title: "Rename course",
					label: "Course name",
					placeholder: "Enter course name",
				},
			},
			deleteItem: {
				toDelete: "To delete:",
				exam: {
					title: "Delete exam?",
					description:
						"The exam will be permanently deleted along with its answers and statistics. This action cannot be undone.",
					confirm: "Delete exam",
				},
				exams: {
					title: "Delete exams?",
					description:
						"The selected exams will be permanently deleted along with their answers and statistics. This action cannot be undone.",
					confirm: "Delete exams",
					count_one: "{{count}} exam",
					count_other: "{{count}} exams",
				},
				course: {
					title: "Delete course?",
					description:
						"The course will be permanently deleted along with your progress. This action cannot be undone.",
					confirm: "Delete course",
				},
				courses: {
					title: "Delete courses?",
					description:
						"The selected courses will be permanently deleted along with your progress. This action cannot be undone.",
					confirm: "Delete courses",
					count_one: "{{count}} course",
					count_other: "{{count}} courses",
				},
				deck: {
					title: "Delete deck?",
					description:
						"The deck will be permanently deleted along with all its flashcards. This action cannot be undone.",
					confirm: "Delete deck",
				},
				decks: {
					title: "Delete decks?",
					description:
						"The selected decks will be permanently deleted along with all their flashcards. This action cannot be undone.",
					confirm: "Delete decks",
					count_one: "{{count}} deck",
					count_other: "{{count}} decks",
				},
				guideSection: {
					title: "Delete chapter?",
					confirm: "Delete chapter",
				},
				flashcard: {
					title: "Delete flashcard?",
					description:
						"The flashcard will be permanently deleted. This action cannot be undone.",
					lastWarning:
						"This is the last flashcard in the deck — removing it will delete the whole deck.",
					confirm: "Delete flashcard",
				},
				comment: {
					title: "Delete comment?",
					description:
						"The comment will be permanently deleted. This action cannot be undone.",
					confirm: "Delete comment",
				},
				removeFromFolder: {
					title: "Remove from folder?",
					description:
						"Selected items will be removed from the folder but won't be permanently deleted. You will still have access to them.",
					confirm: "Remove from folder",
				},
				folder: {
					title: "Delete folder?",
					description:
						"Only the folder will be deleted — all exams, courses, flashcard sets, and notes inside it will remain in your account.",
					confirm: "Delete folder",
				},
				note: {
					title: "Delete note?",
					description:
						"The note will be permanently deleted. This action cannot be undone.",
					confirm: "Delete note",
				},
				account: {
					title: "Delete account?",
					description:
						"The account <0>{{email}}</0> will be permanently deleted. This action cannot be undone.",
					lossesTitle: "You will permanently lose:",
					lossExams: "all your collected data",
					lossStats: "your statistics and learning history",
					lossPlan: "remaining access to the service — with no refund",
					confirmCheckbox:
						"I understand that my data will be permanently deleted and cannot be recovered.",
					confirm: "Delete account",
				},
			},
			editDeck: {
				title: "Edit deck",
				tabs: {
					general: "General",
					flashcards: "Flashcards",
				},
				nameLabel: "Deck name",
				descriptionLabel: "Deck description",
				permissionLabel: "Deck visibility",
				descriptionPlaceholder: "E.g. key concepts in paediatric orthopaedics",
				optional: "optional",
				lastChange: "Last change: {{date}}",
				searchPlaceholder: "Search questions and answers",
			},
			addFlashcard: {
				title: "Add flashcard",
				description:
					"Fill in both sides. You can add several flashcards at once and save them with one button.",
				importFromFile: "Import from file",
				addAnother: "Add another flashcard",
				toSave: "To save:",
				count_one: "{{count}} flashcard",
				count_other: "{{count}} flashcards",
			},
			activatePromocode: {
				primaryText: "Activate gift voucher",
				label: "Gift voucher",
				alert:
					"The code used must be applied when making a purchase on <0>our shopping page</0>. Select your plan and then enter the code in the appropriate space.",
			},
			updateAppModal: {
				primaryText: "Go to {{name}}",
				header: "The new version is here!",
				subtitle: "Go to {{name}} and update the app now.",
			},
			liveUpdateReady: {
				title: "New app version",
				description:
					"A new app update is available. Restart the app to start using it.",
				later: "I'll do it later",
				restart: "Update now",
			},
			edit: {
				deck: {
					header: "Edit Set",
					name: "Set name",
					description: "Description",
				},
			},
			courses: {
				generateCourseFromWrongAnswers: {
					header: "Provide additional information about the course",
					counter: "Number of questions in the course",
				},
			},
			networkError: {
				header: "No connection to the network",
				subheader1:
					"Our application needs a network connection to function properly",
				subheader2: "Please check your internet connection and try again",
			},
			paymentRequired: {
				header: "You don't have active access",
				subheader:
					"Choose a plan that suits you and start learning – or come back to it without losing your progress.",
				primary: "Choose a plan",
				voucher: "I have a voucher",
				profile: "Go to profile",
				voucherCode: "Voucher code",
				voucherPlaceholder: "Enter code",
				activate: "Activate",
			},
			limitedAccess: {
				header: "Unfortunately, you don't have access to this functionality",
				subheader:
					"But don't worry! Go to our website and choose the right plan for yourself.",
				primary: "Choose a plan",
			},
			reportError: {
				success: "Thank you for your notification",
				primary: "Report",
				header: "Report a bug",
				subheader: "What can we improve in this section?",
				stipulation: "Content of the report",
				sourceInfo: "Source of information",
			},
			reportTechnicalIssues: {
				header: "Report a technical issue",
				subheader: "Describe the issue you encountered in the field below",
				stipulation: "Report Content",
				submit: "Report Issue",
				buttonText: "Report a Technical Issue",
				successHeader: "Thank You!",
				successSubheader:
					"Your message has been sent, our team is already working on fixing the issue.",
				successSubmit: "Return to Homepage",
			},
			reportCourseReservations: {
				header: "What can we improve?",
				subheader:
					"Let us know what we can add to make this section more appealing.",
				stipulation: "What are you missing?",
				submit: "Submit",
				successHeader: "Thank you!",
				successSubheader:
					"Your message has been sent, and our team is already getting to work :)",
				successSubmit: "Close",
			},
			requiredUpgradeApp: {
				primary: "Go to {{name}}",
				header: "Your app needs to be updated",
				subheader: "Go to {{name}} and update the app now.",
			},
			wrongExam: {
				title: "Different exam selected",
				description:
					"You are logged in to <0>{{current}}</0>, but your account has active access to <1>{{target}}</1>. You probably picked the wrong exam when logging in.",
				youAreHere: "You are here",
				hasAccess: "Access granted",
				noAccess: "No access",
				stay: "Stay on {{service}}",
				switch: "Go to {{service}}",
			},
			setSpecialisation: {
				header: "Tell us the specialty you're interested in.",
				subheader:
					"This will allow us to tailor our service to your needs in a better way. You can change your preferred specialization at any time in the Profile tab.",
				title: "Specialization",
			},
			shareDeck: {
				copy: "Copy link",
				copied: "Copied",
				private:
					"Your set is private. In the edit tab, change the permission to public to make this set available.",
				link: "Link to the set",
			},
			wrongService: {
				primary: "Go to {{name}}u",
				header: "Oops... I don't think it's here.",
				subheader1: "You seem to have selected the wrong service.",
				subheader2: "Your account is active on {{name}}.",
				subheader3:
					"Go to the correct site and take full advantage of our platform.",
			},
			finishExam: {
				title: "You are leaving the exam",
				lessonTitle: "You are leaving the lesson",
				reviewTitle: "You are finishing the review",
				examNamePlaceholder: "Enter the exam name",
				examNameRequired: "Exam name cannot be empty.",
				examName: "Exam name",
				unresolved:
					"Not all questions have been answered – <0>{{resolved}} of {{total}}</0> answered.",
				finishedInfo:
					"The exam is finished. You can rename it and come back to your answers at any time.",
				recommended: "Recommended",
				later: "Finish later",
				laterDescription:
					"We will save your progress. You can return to the exam at any time.",
				finish: "Finish exam",
				finishLesson: "Finish lesson",
				finishDescription:
					"You will see your result. The remaining questions can no longer be answered.",
				saveAndExit: "Save and exit",
			},
			closeExamView: {
				description: "Exam has been completed",
				primaryText: "Stop browsing",
			},
			finishedCourseExamView: {
				primaryText: "Back to course",
				title: "Do you want to finish reviewing the lessons?",
			},
			finishedExamView: {
				description:
					"All questions have been answered. The test will be saved as completed.",
				primaryText: "Finish",
				title: "Do you want to finish reviewing?",
			},
			unfinishedExamView: {
				description:
					"Not all tasks have been solved. You can end the test or resume it later",
				primaryText: "Finish",
				secondaryText: "Finish later",
				title: "Do you want to end the exam?",
			},
			unfinishedCourseExamView: {
				description:
					"Not all tasks in the lesson have been solved. You can end the lesson or resume it later",
				primaryText: "End lesson",
				secondaryText: "Finish later",
				title: "Do you want to end the lesson?",
			},
		},
		exam: {
			timer: {
				finishedAt: "Time remaining until the end of the exam:",
				startTimer: "Start the timer to activate the exam",
			},
			moderator: "Moderator",
			discussion: "Overview",
			discussionSubText: "Author + AI",
			discussionSubTextAi: "AI",
			discussionSubTextAuthor: "Author",
			discussionAi: "AI Overview",
			discussionAuthor: "Author Overview",
			article: "Articles",
			star: "Favourites",
			source: "Sources",
			comments: {
				title: "Comments",
				addComment: "Add comment or photo",
				replyComment: "Reply to the comment",
				addImage: "Add photo to comment",
				sort: {
					newest: "Newest first",
					oldest: "Oldest first",
					mostPopular: "By popularity",
				},
				filter: {
					onlyEgzaminlek: "EgzaminLEK only",
				},
			},
			more: "More",
			reportError: {
				title: "Report a bug",
				success:
					"Thank you for notification. We'll take care of it as soon as we can!",
				modal: {
					title: "Report a bug",
					subtitle: "What can we improve in this question?",
					outdatedQuestion: "Outdated question",
					wrongAnswer: "Incorrect answer",
					another: "Other",
					missingImages: "Missing images",
					bugInQuestion: "Bug in question",
					withoutCorrectAnswer: "No correct answer",
					wrongCategory: "Wrong question category",
					questionInconsistentWithCurrentKnowledge:
						"The question is inconsistent with current knowledge",
					inputs: {
						reasonOfNotification: "Reason for notification",
						correctAnswer: "Correct answer",
						sourceOfInformation: "Source of information",
						stipulation: "Disclaimer",
					},
				},
			},
			stats: "Statistics",
			questionLevel: "Question difficulty",
			notes: {
				title: "Notes",
				success: "Note added",
				folderTitle: "Notes from folder",
				myNotes: "My notes",
				addNote: "Add note",
				placeholder: "Add a note or image...",
				preview: "Preview",
			},
			images: {
				title: "Graphics for questions",
				discussion: {
					title: "Graphics for overview",
				},
			},
			cemDatabase: "CEM Question Database",
			correctAnswerFromCem:
				"In this question, the correct answer according to the CEM key is: {{answer}}",
			correctAnswerNotExistText:
				"This question does not have a valid answer or has been invalidated.",
			answerNotSetText: "This question has not been answered",
		},
		userDecks: {
			title: "Flashcards",
			tabs: {
				decks: "Your decks",
			},
			search: {
				placeholder: "Search deck",
			},
			empty: "You don't have any decks yet",
			emptyDescription: "Add your first deck and it will appear here",
			emptyButton: "Add deck",
		},
		decks: {
			categoryLabel: "Category:",
			filter: {
				all: "All",
				admin: "Admin",
				users: "Users",
			},
			search: {
				flashcardsCount_one: "{{count}} term",
				flashcardsCount_other: "{{count}} terms",
				preview: "Preview",
				learnSelected: "Learn from these decks",
				learnSuccess: "Decks added to your library",
				maxSelected_one: "You can select up to {{count}} deck",
				maxSelected_other: "You can select up to {{count}} decks",
				empty: "No decks found",
				showAll: "Show all",
				usedCount_one: "Solved {{count}} time",
				usedCount_other: "Solved {{count}} times",
			},
			sort: {
				popularity: "Popularity",
				createdAt: "Created date",
				alphabetical: "Alphabetically",
				flashcardsToResolveCount: "Flashcards to resolve",
				ascending: "Ascending",
				descending: "Descending",
				tooltip: "Sort",
			},
			preview: {
				study: "Study from this set",
				addToList: "Add to list",
				removeFromList: "Remove from list",
				searchPlaceholder: "Search flashcard",
				searchResults: "Search results for: <0>{{query}}</0>",
				noResults: "No results for: {{query}}",
			},
			flashcardsAdded: "Added to set",
			useFlashcardsInAnotherDeck: "Use the flashcard in another set",
			gradeButtons: {
				0: "Repeat",
				1: "Poorly",
				2: "Good",
				3: "Easy",
			},
			knowDontKnow: {
				know: "Know",
				dontKnow: "Don't know",
			},
			modeMenu: {
				trigger: "Mode",
				header: "Choose deck study mode",
				repeatSuffix: "(repeat)",
				loading: "Loading…",
				spacedRepetition: {
					title: "Spaced repetition",
					description:
						"Answer questions and grade your knowledge. Cards you know come back less often, while harder ones come back more often.",
				},
				knowDontKnow: {
					title: "Know / don't know",
					description:
						"Mark whether you know the answer. Cards marked “Know” come back less often, while “Don't know” ones come back more often.",
				},
				search: {
					placeholder: "Search specialisations…",
					empty: "No specialisations matching “{{query}}”",
				},
				view: {
					title: "Browsing",
					description: "Browse flashcards and study at your own pace",
				},
			},
			view: {
				previous: "Previous",
				next: "Next",
			},
			shortcuts: {
				spaceKey: "Space",
				flip: "Flip",
				swipeHint: "Swipe to grade",
			},
			front: "Front",
			showFront: "Show front",
			progress: "Card <0>{{current}}</0> of {{total}}",
			intervalShort: {
				minute: "{{count}}m",
				hour: "{{count}}h",
				day: "{{count}}d",
				month: "{{count}}mc",
				year: "{{count}}r",
			},
			interval: {
				minute_one: "{{count}} min",
				minute_other: "{{count}} min",
				hour_one: "{{count}} h",
				hour_other: "{{count}} h",
				day_one: "{{count}} day",
				day_other: "{{count}} days",
				month_one: "{{count}} month",
				month_other: "{{count}} months",
				year_one: "{{count}} year",
				year_other: "{{count}} years",
			},
			editFlashcard: "Edit flashcard",
			deleteFlashcard: "Delete flashcard",
			frontPlaceholder:
				"Question or term, e.g. “Symptoms of Scheuermann's disease”",
			backPlaceholder:
				"Answer or definition. You can add the source as a quote.",
			back: "Back",
			editor: {
				editing: "Editing flashcard",
				saveShortcut: "Ctrl + Enter to save",
				save: "Save flashcard",
			},
			allFlashcardsResolved: {
				title: "All flashcards in this set have been solved today.",
				subtitle: "Come tomorrow and continue learning!",
				showAnotherDecks: "See other sets",
				continue: "Browse set",
			},
			removeFlashcard: {
				confirm: "Are you sure you want to remove this flashcard from the set?",
			},
		},
		table: {
			elementsOnPage: "Elements on the page",
			exam: {
				title: "Your exams",
				selectedItems: "Selected",
				empty: {
					title: "It's a bit empty here...",
					submitText:
						"Add a new exam using the button in the top right corner or from the panel on the left side.",
				},
				finished: {
					headers: {
						name: "Name",
						countOfQuestions: "Number of questions",
						correctAnswers: "Correct answers",
						wrongAnswers: "Wrong answers",
						result: "Result",
						date: "Last Solved Date",
						actions: "Actions",
					},
				},
				unfinished: {
					headers: {
						name: "Name",
						countOfQuestions: "Number of questions",
						progress: "Progress",
						date: "Last Solved Date",
						actions: "Actions",
					},
				},
				actions: {
					title: "Create an exam from selected",
					generateExamFromWrongAnswers: "Wrong answers",
					generateExamFromStarred: "Favourite Questions",
					removeExams: "Remove selected",
					removeComment: "Delete the comment",
					replyComment: "Reply the comment",
				},
				tabs: {
					unfinishedExams: "Unfinished Tests",
					finishedExams: "Completed Tests",
					unfinished: "Unfinished",
					finished: "Completed",
				},
			},
			courses: {
				headers: {
					name: "Name",
					progress: "Progress",
					date: "Last solved date",
					countOfLessons: "Number of lessons remaining",
					actions: "Actions",
				},
				actions: {
					removeCourses: "Remove selected",
					title: "Actions from marked",
				},
				title: "Your Courses",
				tabs: {
					courses: "Your courses",
				},
				empty: {
					title: "It's a bit empty here...",
					submitText:
						"Add a new course using the button in the top right corner or from the panel on the left side.",
				},
			},
			decks: {
				title: "Your decks",
				empty: {
					title: "It's a bit empty here...",
					submitText:
						"Add a new deck using the button in the top right corner or from the panel on the left side.",
				},
				headers: {
					name: "Name",
					countToResolve: "Number of flashcards remaining",
					count: "Number of flashcards in the set",
					date: "Last solved date",
					code: "Set code",
					actions: "Actions",
				},
				actions: {
					title: "Actions from selected",
					remove: "Remove Sets",
				},
				tabs: {
					decks: "Your decks",
				},
			},
		},
		courses: {
			week: "Week",
			finished: "Completed",
			noDescription: "This course does not contain a description",
		},
		stats: {
			exam: {
				title: "Exam Statistics",
				correctAnswers: "Correct answers",
				wrongAnswers: "Wrong answers",
				dateOfSave: "Recently",
			},
		},
		profile: {
			accountActiveUntil: "Account active until",
			purchase: "Extend",
			tabs: {
				password: "Password",
				profile: "Profile",
				myProfile: "My account",
				blog: "blog",
				promocode: "Activate gift voucher",
				removeAccount: "Delete account",
				refresh: "Refresh account",
				purchase: "Buy Exam Access",
				information: "Information and updates",
				logOut: "Log out",
			},
			changePassword: "Change Password",
			university: "University",
			userData: "Your data",
		},
		statsBox: {
			correctAnswers: "Correct answers",
			wrongAnswers: "Wrong answers",
			title: "Statistics",
		},
		articles: {
			back: "Knowledge base",
			examName: "Article question",
			generate: "Solve questions from the article",
			generating: "Generating an exam...",
			actions: "Actions",
			showAll: "Open all tabs",
			contents: "Table of Contents",
			images: "Images for sections",
			sections: "Sections",
			tags: "Tags",
		},
		relations: {
			relatedArticles: "Related Articles",
			recomendedArticles: "Recommended Articles",
		},
		search: {
			articles: {
				read: "Read",
			},
			filters: {
				title: "Filters",
				active_one: "{{count}} active filter",
				active_other: "{{count}} active filters",
				noneActive: "No active filters",
				pin: "Pin filters",
				unpin: "Unpin filters",
				selected_one: "{{count}} selected",
				selected_other: "{{count}} selected",
				remove: "Remove filter {{name}}",
				clear: "Clear",
				close: "Close",
				showResults: "Show results",
				showResultsCount_one: "Show {{count}} result",
				showResultsCount_other: "Show {{count}} results",
				chips: {
					departments: "Departments",
					typeOfExam: "Question base",
					cemVersions: "CEM base version",
					terms: "Exam sessions",
					consultants: "Consultants",
					level: "Difficulty",
					additionalOption: "Options",
					searchValue: "Phrase",
					question: "Question",
					author: "Author",
				},
			},
			emptyState: "No results were found for the specified filters",
			empty: {
				questions: {
					title: "No questions",
					titlePhrase: "No questions for “{{phrase}}”",
					description:
						"Try a shorter phrase or a different form of the word, or remove some filters.",
				},
				articles: {
					title: "No articles",
					titlePhrase: "No articles for “{{phrase}}”",
					description:
						"We don't have an article on this topic yet. Check the results in other tabs or browse the Knowledge base by section.",
				},
				decks: {
					title: "No flashcards",
					titlePhrase: "No flashcards for “{{phrase}}”",
					description:
						"No flashcards match this phrase. Create your own deck or look for the topic in questions and articles.",
				},
				clearFilters: "Clear filters",
			},
			decks: {
				noDescription: "No set description",
			},
		},
		course: {
			lessons: {
				revision: "Revision",
				challenge: "Challenge",
				blockedRevisionHint:
					"Complete the previous 5 days to unlock the revision",
				blockedChallengeHint:
					"Complete the whole section to unlock the challenge",
			},
		},
		infiniteScroll: {
			loading: "Loading...",
			endOfList: "You don't have any more notifications",
		},
		notifications: {
			createdAt: "Creation Date: {{date}}",
			expired: "Expires: {{date}}",
			emptyState: "You don't have any notifications",
			title: "Notifications",
			comment: {
				title:
					"User <0>{{username}}</0> commented on the question you are following",
				days: {
					plural: "{{days}} days ago",
					singular: "{{days}} a day ago",
					lastDay: "Today",
					expired: "",
				},
			},
			commentAnswer: {
				title: "User <0>{{username}}</0> replied to your comment.",
			},
			commentLike: {
				title: "User <0>{{username}}</0> liked your comment.",
			},
			forumQuestionAnswer: {
				title: "User <0>{{username}}</0> answered your question.",
			},
			questionChanged: {
				title: "The question you're watching has been updated.",
				subtitle: "{{message}}",
			},
			link: {
				expired: {
					days: {
						plural: "Expires in {{days}} days",
						singular: "Expires in {{days}} day",
						lastDay: "Expires in less than a day",
						expired: "Expired...",
					},
				},
			},
			reportedErrorResponse: {
				title:
					"User <0>{{username}}</0> has resolved your objection to the question.",
			},
			resolveNotification: "Set as read",
			editQuestionsButton: "Edit Question",
			actions: {
				setAsRead: "Mark as read",
				stopSubscribe: "Unfollow",
				remove: "Remove notifications",
				removeAll: "Remove all notifications",
				setAllAsRead: "Mark all as read",
			},
		},
		uploader: {
			or: "or",
			dropFile: "Drop file",
			takePhoto: "Take a photo",
			chooseFile: "Choose file",
			imageFormatsInfo:
				"Allow only: jpg, png, svg. Max size: <0>{{maxMB}} MB</0>",
			importFiles: "Import files",
			formats: "Formats",
			fileTooLarge: "File is too large",
			maxSizeHint: "Maximum size: {{maxMB}} MB.",
			fileReady: "File ready. The thumbnail shows how the image will look.",
		},
		sources: {
			addNew: "Add source:",
			placeholderSelect: "Find source and author",
			placeholderInput: "Add new source (Title of the book, author)",
			hintSelect: "Add new source",
			hintInput: "Find source",
			customSourceInfo:
				"The new source requires manual verification by our team. Your comment will appear on the site as soon as the source you provided is approved.",
			useExistingSources: "Use existing <0>sources.</0>",
			addNewSource: "Can't you see the source? <0>Add new.</0>",
		},
		ai: {
			discussion: {
				missing: "No AI discussion for this question yet.",
				generate: "Generate AI discussion",
			},
			questionDetails: {
				userDetailsMessage: "Help me understand this question.",
			},
			chatbot: {
				rateQuestion: "How do you rate the answer?",
				userRatings: "User ratings",
				responseGood: "Correct discussion",
				responseBad: "Incorrect discussion",
				reviewPlaceholder:
					"What can we improve or what's missing in this discussion",
				reviewSent: "Thank you for your feedback",
				loader: "Generating response",
				header: "Tutor AI",
				overviewHeader: "Overview AI",
				aiInfo:
					"The AI function is powered by AI, so errors are possible. Please verify the information carefully.",
			},
			regenerate: {
				button: "Regenerate discussion",
			},
			approval: {
				approve: "Approve discussion",
				revoke: "Revoke approval",
				approvedBy: "Accepted by {{user}} on {{date}}",
				approvedByInline: "Verified by <0>{{user}}</0> on <1>{{date}}</1>",
				verifiedByModerator: "Discussion verified by moderator",
			},
			edit: {
				button: "Edit",
				cancelEdit: "Cancel edit",
				save: "Save",
				saving: "Saving...",
				cancel: "Cancel",
				saveSuccess: "Changes saved",
				saveError: "Failed to save changes",
			},
			reviews: {
				title: "Reviews from users",
				empty: "No reviews",
				loading: "Loading...",
				loadMore: "Load more",
				showing: "{{loaded}} of {{total}}",
				filter: {
					all: "All",
					waiting: "Waiting",
					resolved: "Resolved",
				},
				sort: {
					newest: "Newest",
					oldest: "Oldest",
					updated: "Recently updated",
					resolved: "Recently resolved",
				},
				status: {
					waiting: "Waiting",
					resolved: "Resolved",
				},
				markAsResolved: "Mark as resolved",
				markedResolved: "Marked as resolved",
				revertResolve: "Revert acceptance",
				revertedToWaiting: "Acceptance reverted",
				resolvedBy: "Resolved by {{user}} ({{date}})",
			},
			context: {
				title: "Context (RAG sources)",
				loading: "Loading...",
				empty: "No context",
				count: "Chunks: {{count}}",
				filter: {
					all: "All",
					cited: "Cited only",
				},
			},
		},
		globalChatbot: {
			open: "Open AI Tutor",
			title: "AI Tutor",
			new: "New",
			newConversation: "New conversation",
			loadingConversation: "Loading conversation...",
			collapse: "Collapse to panel",
			expand: "Expand to full width",
			emptyState: "Start a conversation by typing a question below",
			composerPlaceholder: "Write your question…",
			attachQuestion: "Attach this question to the conversation",
			attachedQuestion: {
				label: "Question from the page",
			},
			thinking: "Analyzing question...",
			details: {
				title: "Conversation details",
				promptsCount_one: "{{count}} prompt",
				promptsCount_other: "{{count}} prompts",
				questionsCount_one: "{{count}} question",
				questionsCount_other: "{{count}} questions",
				contextQuestions: "Questions used as context",
			},
			history: {
				title: "Question history",
				today: "Today",
				yesterday: "Yesterday",
				searchPlaceholder: "Search…",
				delete: "Delete conversation",
				popoverTitle: "Conversation history",
				seeAll: "See all",
				empty: "No conversations",
				noResults: 'No results for "{{query}}"',
			},
			instructions: {
				title: "How to use",
			},
			limits: {
				period: {
					daily: "questions today",
					weekly: "questions this week",
					monthly: "questions this month",
					last30Days: "questions in the last 30 days",
				},
				cadence: {
					daily: "daily",
					weekly: "weekly",
					monthly: "monthly",
					last30Days: "every 30 days",
				},
				tooltip: "Limit resets {{cadence}} at {{time}}",
			},
		},
		commentedQuestions: {
			title: "News",
			userComment: "commented a question from sessions",
		},
		tawk: {
			chatTitle: "Chat",
		},
		news: {
			tabs: {
				lastCommented: "Recently Commented",
				community: "Chat",
			},
			buttons: {
				addQuestion: "Ask a Question",
			},
			searchPlaceholder: "Search by question content",
			forum: {
				userComment: "asked a question",
				addAnswer: "Answer the question",
				seeAnswers: "View answers",
			},
		},
		aiPlayground: {
			params: {
				historyLength: "Chat history length (0–10)",
				questionId: "Question ID (context)",
			},
		},
		aiUserChat: {
			thinking: "Thinking...",
			startConversation:
				"Start a conversation by typing a question in the field below",
			remaining: "Remaining",
			of: "of",
			questions: "questions",
		},
		userAccount: {
			successBox: {
				defaultMessage: "Changes saved successfully",
			},
			contextContainer: {
				saveButton: "Save changes",
				cancelButton: "Cancel",
			},
			passwordSection: {
				sectionTitle: "Password",
				editButton: "Edit",
				changePasswordTitle: "Change password",
			},
			subscriptionSection: {
				sectionTitle: "Subscription",
				subscriptionWarning: "Your subscription is about to expire",
				specialisationLabel: "Specialization",
				accessTypeTitle: "Access type",
				accessTypeLek: "LEK exam",
				accessTypeLdek: "LDEK exam",
				expiryDateLabel: "Expiry date",
				extendButton: "Extend",
				activateButton: "Activate",
				noSubscription: "No active subscription",
			},
			accountSection: {
				editButton: "Edit",
				usernameLabel: "Username",
				emailLabel: "Email",
				loginLabel: "Login",
			},
			profile: {
				mainTitle: "My account",
			},
			folder: {
				search: "Search in folder",
				tabs: {
					all: "All",
					flashcards: "Flashcards",
					exams: "Exams",
					courses: "Courses",
					notes: "Notes",
				},
				showAll: "Show all",
				loadMore: "Load more",
				loading: "Loading...",
				showingCount: "Showing:\n{{loaded}} of {{total}} items",
				selectMany: "Select many",
				selectedElements: "Selected elements",
				move: "Move",
				copy: "Copy",
				moveToFolder: "Move to folder",
				moveToFolderTitle: "Move to folder",
				removeFromFolder: "Remove",
				removeFromFolderTitle: "Remove from folder",
				removeFromFolderDescription:
					"Selected items will be removed from the folder but won't be permanently deleted. You will still have access to them.",
				selectedCount: "Selected: {{count}}",
				noOtherFolders: "No other folders",
				movedToFolderSuccess: "Moved to folder",
			},
			chatWidget: {
				loading: "Loading chat...",
				openChat: "Tap to open chat",
				greeting: "Hi",
				startInstruction:
					"Tap the bubble below to start a chat with our assistant.",
				closeInstruction: "Once you're done, close this page :)",
				helpQuestion: "How can we help?",
				startChat: "Start a chat",
				startChatSubtitle: "Help from our assistant",
				start: "Start",
				checkFaq: "Check our FAQ",
				checkFaqSubtitle: "Answers to common questions",
				openFaq: "Open",
			},
		},
		sort: {
			descending: "Descending",
			ascending: "Ascending",
			tooltip: "Sort",
		},
		admin: {
			questions: {
				title: "Questions",
				search: "Search by question content, answers or question ID…",
				empty: "No questions for these filters",
				edit: "Edit",
				backToList: "Questions list",
				cemId: "CEM ID",
				expandComments: "Expand comments",
				expandDiscussions: "Expand discussions",
				canceled: "Question cancelled – no correct answer",
				discussion: {
					own: "Own",
					rag: "RAG",
					ragAccepted: "RAG ✓",
					ai: "AI",
				},
				values: {
					yes: "Yes",
					no: "No",
					accepted: "Accepted",
					notAccepted: "Not accepted",
					canceled: "Cancelled",
				},
				view: {
					title: "View",
					subtitle: "Drag to reorder columns",
					visible: "Visible",
					hidden: "Hidden",
				},
				columns: {
					id: "ID",
					content: "Question",
					status: "Discussion status",
					type: "Discussion type",
					ai: "AI discussion",
					rag: "RAG discussion",
					articles: "Articles",
					correctAnswer: "Correct",
					correctPercent: "% correct",
					level: "Difficulty",
					canceled: "Cancelled",
					images: "Images",
					inBase: "In question bank",
					cemNumber: "CEM test no.",
					department: "Department",
					session: "Session",
					discussion: "Discussion status / type",
					comments: "Comments",
				},
				status: {
					none: "None",
					accepted: "Accepted",
					unaccepted: "Not accepted",
				},
				type: {
					own: "Own",
					rag: "RAG",
					none: "None",
				},
			},
			question: {
				edit: "Edit question",
				id: "Question id: {{id}}",
				editMode: "Edit mode · admin",
				content: "Question content",
				answers: "Answers",
				answersHint: "Select the circle to change the correct answer",
				markCorrect: "Correct: {{letter}}",
				correct: "Correct",
				noCorrect: "No correct answer",
				noCorrectHint: "Question cancelled – does not count towards the score",
				save: "Save changes",
				saveSuccess: "Question saved",
			},
			images: {
				title: "CDN images",
				browse: "Search",
				search: "Search by file name...",
				count_one: "<0>{{count}}</0> file · newest first",
				count_other: "<0>{{count}}</0> files · newest first",
				hint: "Click “Copy URL” to paste the image address into a question",
				empty: "No files",
				preview: "Preview",
				copy: "Copy URL",
			},
			upload: {
				viewOnly:
					"You only have view access to images — browse them with “Search”.",
				title: "Upload image",
				graphic: "Image",
				infographic: "Infographic",
				submit: "Save",
				copy: "Copy link",
				copied: "Link copied",
				error: "Failed to upload file",
				chooseFile: "Choose file",
				graphicHint: "Image to embed in content. Max size: {{maxMB}} MB.",
				infographicHint:
					"The infographic will be attached to the question. Max size: {{maxMB}} MB.",
				wrongFormat: "Unsupported file format",
				tooBig: "File is too large (max {{maxMB}} MB)",
				dropzone: "Drag a file here or <0>choose from disk</0>",
				footer: "Formats: {{formats}} · max <0>{{maxMB}} MB</0>",
			},
			decks: {
				add: "Add decks",
			},
			blog: {
				posts: {
					title: "Posts",
					search: "Search by title…",
					empty: "No posts",
				},
				post: {
					newTitle: "New post",
					create: "Add post",
					createSuccess: "Post has been added",
					save: "Save post",
					saveSuccess: "Post has been saved",
					published: "Published",
					draft: "Draft",
					tags: "Tags",
					saveAndPublish: "Save and publish",
					saveAsDraft: "Save as draft",
					chooseTags: "Choose tags",
					pickTags: "Post tags",
					applyTags: "Apply",
				},
				tags: {
					title: "Tags",
					add: "Add tag",
					newTitle: "New tag",
					editTitle: "Edit tag",
					edit: "Edit",
					save: "Save tag",
					name: "Name",
					slug: "Slug (optional)",
					slugPlaceholder: "Empty = generated from name",
					actions: "Actions",
					delete: "Delete",
					deleteTitle: "Delete tag #{{name}}?",
					deleteDescription:
						"The tag will be removed from all posts ({{count}}). This cannot be undone.",
					choosePosts: "Choose posts",
					attachTitle: "Assign posts",
					attachSave: "Save",
					empty: "No tags",
					search: "Search tags…",
					noPosts: "No posts with this tag",
					detach: "Remove from tag",
					emptyDescription: "Add the first tag to assign posts to it.",
					postsCount_one: "{{count}} post",
					postsCount_other: "{{count}} posts",
				},
			},
			articleCategories: {
				listTitle: "Categories",
				search: "Search categories…",
				untagged: "no tag",
				tagArticles: "Articles tagged {{name}}",
				untaggedArticles: "Articles without a tag",
				noArticles: "No articles",
				emptyTitle: "No categories",
				emptyDescription: "Add the first category to assign articles to it.",
				tagsCount_one: "{{count}} tag",
				tagsCount_other: "{{count}} tags",
				add: "Add category",
				newTitle: "New category",
				newTagTitle: "New tag in {{name}}",
				addTag: "Add tag",
				name: "Name",
				empty: "No categories",
				attachTitle: "Assign articles",
				attachTo: "Assign articles: {{name}}",
				chooseArticles: "Choose articles",
				attachSave: "Save",
				articlesCount_one: "{{count}} article",
				articlesCount_other: "{{count}} articles",
			},
			linked: {
				remove: "Remove",
			},
			checkDrawer: {
				selected: "Selected: {{count}}",
				search: "Search…",
				empty: "No results",
			},
			article: {
				previewDark: "Preview in dark theme",
				previewLight: "Preview in light theme",
				untitled: "Untitled",
				saveOptions: "Save options",
				preview: "Preview",
				backToEdit: "Back to editing",
				add: "Add article",
				newTitle: "New article",
				create: "Add article",
				createSuccess: "Article added",
				back: "Knowledge base",
				toc: "Contents",
				edit: "Edit article",
				title: "Title",
				content: "Content",
				save: "Save article",
				cancel: "Cancel",
				saveSuccess: "Article saved",
				cancelConfirm: "Your changes to the article will be lost.",
			},
			ai: {
				error: "Failed to generate AI content.",
			},
			comments: {
				title: "Comments",
				search: "Search comment text…",
				tabs: {
					questions: "Under questions",
					forum: "Chat",
				},
				answered: "answered",
				notAnswered: "no reply",
				empty: "No comments",
				resolved: "resolved",
				status: {
					title: "Status",
					all: "All",
					todo: "Without replies",
					resolved: "Resolved",
				},
				resolve: {
					mark: "Mark as resolved",
					undo: "Undo",
					notFound: "This comment no longer exists",
				},
				replies_one: "{{count}} reply",
				replies_other: "{{count}} replies",
				question: "Question #{{id}}",
				openQuestion: "Open question",
				deleteThread: "Delete thread",
				lastCommented: "Recently commented questions",
				ai: {
					promptInfo:
						"Write what you want to reply or add some context. The model knows the question, answers, correct answer and the comment. You can leave it empty.",
					promptPlaceholder:
						"E.g. point out that the 2024 guidelines changed this.",
					generate: "Reply with AI",
					confirm: {
						title: "Replace the reply?",
						subtitle: "The current reply will be replaced with the AI reply.",
					},
				},
			},
			revealAnswers: "Show correct answers",
			discussion: {
				edit: "Edit explanation",
				content: "Explanation",
				save: "Save explanation",
				saveSuccess: "Explanation saved",
				writeOwn: "Write own",
				deleteOwn: "Delete own",
				deleteSuccess: "Own explanation deleted",
				deleteConfirm: {
					title: "Delete own explanation?",
					subtitle:
						"The explanation and sources will be deleted. In PES the RAG explanation will be shown instead, if it exists.",
				},
				type: { own: "Own", rag: "RAG" },
				rag: {
					generate: "Generate RAG",
					tab: "RAG explanation",
					transferConfirm: {
						title: "Replace the explanation?",
						subtitle:
							"The current explanation and sources will be replaced with the RAG explanation and the sources it cites.",
					},
				},
				draftRestored: "Restored an unsaved draft from this browser.",
				cancelConfirm: {
					title: "Discard unsaved changes?",
					subtitle: "Your changes to the explanation and sources will be lost.",
				},
			},
			purchases: {
				title: "Purchases report",
				subtitle: "Paid orders and revenue by month and access length",
				superuserOnly: "Visible to superusers only",
				tabs: {
					report: "Period report",
					compare: "Compare periods",
					reportHint: "totals and table for the selected months",
					compareHint: "A vs B · packages, months, specialisations",
				},
				grossHint:
					"gross amounts in PLN, from the amount actually paid (after discounts)",
				compare: {
					preset: {
						title: "Preset:",
						thisMonth: "This month vs previous",
						thisYear: "This year vs previous",
						custom: "Custom range",
					},
					period: "Period {{side}}",
					submit: "Compare",
					nextYear: "Same period B",
					toBeforeFrom: "End can't be before start",
					new: "new",
					partial: "data up to today",
					periodA: "period A",
					soldB: "Packages sold · B",
					soldHint: "paid orders only",
					revenueB: "Revenue · B",
					revenueHint: "from the amount actually paid, not the price list",
					byDays: "By package (access length)",
					columns: {
						package: "Package",
						sold: "Sold",
						change: "Change",
						revenue: "Revenue",
						changeMoney: "Change PLN",
						units: "Units",
					},
					total: "Total",
					byMonth: "By month",
					byMonthHint: "· units",
					bySpec: "By specialisation",
					pesOnly: "· PES only",
					empty: "No paid orders in either period",
					emptyHint: "Change periods A and B.",
					footnote:
						"Package = access length (days), as in the report. Drops in red with a minus sign. Months in UTC, paid (completed) orders only.",
				},
				filters: {
					from: "From (month)",
					to: "To (month)",
					toBeforeFrom: "“To” can't be before “From”",
					spec: "Specialisation",
					allSpecs: "All specialisations",
					submit: "Show report",
				},
				range: {
					title: "Quick range:",
					previousMonth: "Previous month",
					last3Months: "Last 3 months",
					yearToDate: "Year to date",
					last12Months: "Last 12 months",
				},
				csv: "Download CSV",
				csvDays: "Access length (days)",
				csvRevenue: "Revenue (PLN)",
				paidOrders: "Paid orders",
				revenue: "Revenue",
				revenueHint: "gross, incl. grosze",
				byDays: "By access length",
				byDaysHint: "for the selected period · purchases · revenue · share",
				days_one: "{{count}} day",
				days_other: "{{count}} days",
				columns: {
					spec: "Specialisation",
					month: "Month",
					days: "Access length",
					purchases: "Purchases",
					revenue: "Revenue",
				},
				view: {
					label: "View",
					spec: "Per specialisation",
					rows: "All rows",
					month: "Per month",
				},
				monthTotal: "Total {{month}}",
				periodTotal: "Total for period",
				rowsCount_one: "{{count}} row",
				rowsCount_other: "{{count}} rows",
				specCount_one: "{{count}} specialisation",
				specCount_other: "{{count}} specialisations",
				empty: "No paid orders in the selected period",
				emptyHint: "Change the month range.",
				emptyHintSpec: "Change the month range or pick “All specialisations”.",
				footnote:
					"Months are counted in UTC – an order placed on the 1st between 00:00 and ~02:00 Polish time falls into the previous month. Paid (completed) orders only. Months with no purchases are not listed.",
			},
			users: {
				title: "Users",
				sort: {
					title: "Sort by",
					newest: "Newest accounts",
					oldest: "Oldest accounts",
					lastLoginDesc: "Recently logged in",
					lastLoginAsc: "Least recently logged in",
					emailAsc: "Email A–Z",
					emailDesc: "Email Z–A",
					usernameAsc: "Username A–Z",
					usernameDesc: "Username Z–A",
				},
				search: "Search by username, email, full name or ID…",
				empty: "No users match these filters",
				found: "Found {{total}}",
				pageOf: "page {{page}} of {{pages}}",
				banned: "Comments blocked",
				copied: "Copied: {{value}}",
				clickToCopy: "Click to copy",
				login: "username",
				email: "email",
				back: "Back",
				backToList: "Back to list",
				notFound: "No user with id {{id}}",
				columns: {
					user: "User",
					id: "ID",
					access: "Access",
					lek: "LEK access",
					pes: "PES access",
					email: "E-mail",
					name: "Full name",
					spec: "PES specialisation",
					lastLogin: "Last login",
					joined: "Joined",
				},
				filters: {
					access: "Access",
					all: "All",
					withAccess: "With active access",
					withoutAccess: "Without active access",
					product: "Product",
					bothProducts: "Both",
					onlyLek: "LEK only",
					onlyPes: "PES only",
					account: "Account",
					onlyStaff: "Staff only",
					banned: "Comments blocked",
					spec: "Current PES specialisation",
					allSpecs: "All",
				},
				access: {
					title: "Access",
					until: "until {{date}}",
					expired: "expired {{date}}",
					active: "active",
					never: "never",
					lifetime: "lifetime",
					statusActive: "Active",
					statusExpired: "Expired",
					empty: "No access",
					extra: "Extra questions",
					extraShort: "Extra",
					lekScope: "Questions, discussions, articles",
					wholeProduct: "Whole product",
					activeCount_one: "{{count}} active",
					activeCount_other: "{{count}} active",
					expiredCount_one: "{{count}} expired",
					expiredCount_other: "{{count}} expired",
					source: {
						userinfo: "account date",
						specialization: "specialisation purchase",
						legacy: "legacy package",
					},
					extend: {
						title: "Extend access",
						submit: "Extend",
						currentUntil: "currently until {{date}}",
						newDate: "New end date",
						plusDays_one: "+{{count}} day",
						plusDays_other: "+{{count}} days",
						coveredByPes:
							"Whole PES access is active and overrides this date — the user will see it only after whole PES expires.",
					},
					grant: {
						title: "Grant access",
						product: "Product",
						specs: "PES specialisations",
						addSpec: "Add specialisation…",
						specRequired: "Pick a specialisation or “All”",
						until: "Access until",
					},
					renew: {
						title: "Renew access",
						submit: "Renew",
					},
					revoke: {
						submit: "Revoke",
						title: "Revoke access?",
						warning:
							"{{label}} — access ends right away (end date: yesterday). You can renew it later.",
						done: "Access revoked.",
					},
				},
				ban: {
					ban: "Ban",
					unban: "Unban",
					banTitle: "Ban {{name}}?",
					unbanTitle: "Unban {{name}}?",
					banWarning:
						"The user won't be able to post comments. You can undo this any time.",
					unbanWarning: "The user will be able to post comments again.",
					banned: "User banned.",
					unbanned: "User unbanned.",
				},
				staff: {
					grant: "Grant staff",
					revoke: "Revoke staff",
					grantTitle: "Grant staff to {{name}}?",
					grantWarning:
						"They will get access to the admin panel. What they see depends on groups and permissions.",
					granted: "Staff granted. Set permissions in the Permissions tab.",
				},
				account: {
					title: "Account",
					joined: "Joined",
					lastLogin: "Last login",
					banned: "Banned",
					active: "Account active",
					service: "Service",
				},
				orders: {
					title: "Orders",
					paidSum: "paid total {{sum}}",
					empty: "No orders",
					id: "No.",
					date: "Date",
					price: "Amount",
					days: "Period",
					daysCount_one: "{{count}} day",
					daysCount_other: "{{count}} days",
					product: "Product",
					source: "Source",
					invoice: "Invoice",
					noInvoice: "no invoice",
					status: {
						title: "Status",
						completed: "Paid",
						processing: "Unpaid",
						rejected: "Rejected",
					},
				},
			},
			logs: {
				title: "Change history",
				subtitle:
					"Every change from the admin panel and the old Django admin (since 2017) · superuser only · local time",
				search:
					"Search by object description (e.g. /admin/articles/12, “question”) or object ID…",
				empty: "No entries for these filters",
				object: "Object",
				deletedAccount: "deleted account",
				djangoSource: "{{type}} · old Django admin",
				changedFields: "Changed fields: {{fields}}",
				questionHistory: "Change history of this question",
				articleHistory: "Change history of this article",
				columns: {
					time: "When",
					action: "Action",
					user: "Who",
					object: "Object",
					change: "What changed",
				},
				action: {
					added: "Added",
					changed: "Changed",
					deleted: "Deleted",
				},
				period: {
					today: "Today",
					yesterday: "Yesterday",
					"7d": "7 days",
					"30d": "30 days",
					month: "This month",
					all: "All",
				},
				filters: {
					period: "Period",
					from: "From",
					to: "To",
					action: "Action",
					user: "Changed by",
					type: "Object type",
					objectId: "Object ID",
					objectIdPlaceholder: "e.g. 12",
				},
				details: {
					title: "Entry details",
					id: "Entry ID",
					utc: "Time (UTC)",
					admin: "Admin",
					type: "Object type",
					objectId: "Object ID",
					raw: "Change message (raw)",
					note: "History shows which fields changed, without the “from → to” values.",
					open: "Open {{object}}",
				},
				types: {
					questionLek: "LEK question",
					questionPes: "PES question",
					questionLdek: "LDEK question",
					questionPesDjango: "PES question (Django)",
					questionLekDjango: "LEK question (Django)",
					articleDjango: "Article (Django)",
					article: "Article",
					articleCategory: "Article category",
					articleTag: "Article tag",
					blogPost: "Blog post",
					blogTag: "Blog tag",
					user: "User",
					group: "Permission group",
					permission: "Permission",
					image: "Image",
					notification: "Notification",
					admin: "Panel action",
				},
			},
			textStyles: {
				title: "Text styles",
				sections: {
					headings: "Headings",
					paragraph: "Paragraph and formatting",
					colors: "Text colors",
					highlights: "Highlights",
					align: "Alignment",
					bulletList: "Bullet list",
					orderedList: "Numbered list",
					taskList: "Task list",
					callouts: "Callouts",
					blockquote: "Quote",
					codeBlock: "Code block",
					table: "Table",
					tableFigure: "Table with title and note",
					image: "Image",
					imageCaption: "Image with caption",
					hr: "Horizontal rule",
				},
			},
			navbar: {
				badge: {
					short: "Admin",
					label: "Panel",
					title: "Administration",
				},
				comments: "Comments",
				logs: "Change history",
				purchases: "Purchases report",
				groups: {
					stats: "Statistics",
					users: "Users",
					ai: "AI",
					content: "Content",
					blog: "Blog",
				},
				blogPosts: "Posts",
				blogTags: "Tags",
				articleCategories: "Categories",
				usersList: "Users",
				permissions: "Permissions",
				home: "Home",
				uploadImage: "Images",
				textStyles: "Text styles",
				aiChat: "AI chat",
				guide: "Guide",
				questions: "Questions",
				articles: "Articles",
				decks: "Flashcards",
				notifications: "Notifications",
			},
			notifications: {
				viewOnly:
					"View only – sending requires write access to the Notifications section.",
				title: "New notification",
				service: "Service",
				specs: "Specialisations",
				specsPlaceholder: "Select specialisations",
				allSpecs: "All specialisations",
				noSpecs: "No results",
				type: "Type",
				types: {
					info: "Message",
					link: "External link",
					localLink: "In-app link",
				},
				url: "URL",
				localUrl: "In-app path",
				message: "Content",
				messagePlaceholder: "Notification content…",
				endDate: "Valid until",
				summary: "{{audience}} · valid until {{date}}",
				sent_one: "Sent {{count}} notification.",
				sent_other: "Sent {{count}} notifications.",
				sendFailed: "{{failed}} of {{total}} notifications failed: {{message}}",
				errors: {
					specs: 'Select specialisations or check "All".',
					externalUrl: "External link must start with https://",
					localUrl: "Path must start with /",
					message: "Content cannot be empty.",
					endDate: "Date must be in the future.",
				},
				confirm: {
					title: "Send notification?",
					warning: "It cannot be undone or edited. It disappears on {{date}}.",
				},
				preview: {
					title: "Preview",
					description: "This is how the user sees it after clicking the bell.",
					placeholder: "Notification content will appear here.",
					audience: "To",
					link: "Link",
					expires: "Expires",
				},
			},
			permissions: {
				retry: "Try again",
				unsaved: "You have unsaved changes",
				unsavedPrompt: "You have unsaved changes. Leave without saving?",
				saveFailed: "Could not save. Your changes are still in the form.",
				codesCount_one: "{{count}} code",
				codesCount_other: "{{count}} codes",
				codes: {
					add: "Add permission",
					remove: "Remove {{code}}",
				},
				picker: {
					search: "Search by code or name…",
					given: "granted",
					footer: "{{shown}} of {{total}} codes · Enter adds, Esc closes",
				},
				grant: {
					search: "Search areas…",
					remove: "Revoke direct access",
				},
				pickArea: {
					title: "Add area",
					search: "Search areas by name or code…",
					count: "{{shown}} of {{total}} areas",
					countFor: "{{shown}} of {{total}} areas for “{{search}}”",
					alreadySet: "set: {{level}}",
					done: "Done",
					toGroup: "to group",
					toNewGroup: "to the new group",
					directFor: "directly for",
					outsideGroups: "outside groups",
					hint: "Click Read or Write next to areas, then “Done”",
					pickedCount_one: "{{count}} area selected",
					pickedCount_other: "{{count}} areas selected",
					superuserOnly: "superuser only",
				},
				addStaff: {
					title: "Add to staff",
					description:
						"Staff grants access to the admin panel. What the person can do there is set by groups and permissions.",
					search: "Search accounts by name, e-mail or login…",
					minChars: "Type at least 3 characters.",
					grant: "Grant staff",
					granted: "Staff granted. The change takes effect within 30 s.",
				},
				revokeStaff: {
					action: "Revoke staff",
					title: "Revoke staff: {{name}}?",
					warning:
						"The person will lose access to the panel. Groups and permissions stay but stop working.",
					done: "Staff revoked. The change takes effect within 30 s.",
				},
				readOnly: {
					panelGroup:
						"Read-only – this group grants panel access; only a superuser can change it.",
					noWrite:
						"Read-only – you don't have write access to the permissions panel.",
				},
				superuser: {
					grant: "Grant superadmin",
					revoke: "Revoke superadmin",
					grantTitle: "Grant superadmin: {{name}}?",
					revokeTitle: "Revoke superadmin: {{name}}?",
					granted: "Superadmin granted.",
					revoked: "Superadmin revoked.",
					grantWarning:
						"A superadmin has full access to all areas and the permissions panel, regardless of groups. Granting also sets staff.",
					revokeWarning:
						"The person loses full access. Staff, groups and direct permissions stay.",
				},
				userGroups: {
					add: "Add to group",
					remove: "Remove from group",
					none: "Not in any group.",
					for: "for",
					pickedCount_one: "{{count}} group selected",
					pickedCount_other: "{{count}} groups selected",
				},
				level: {
					none: "None",
					read: "Read",
					write: "Write",
				},
				tabs: {
					groups: "Groups",
					areas: "Permissions",
					users: "Users",
					groupsCount_one: "{{count}} group",
					groupsCount_other: "{{count}} groups",
					areasCount_one: "{{count}} area",
					areasCount_other: "{{count}} areas",
					usersCount_one: "{{count}} staff member",
					usersCount_other: "{{count}} staff members",
				},
				forbidden: {
					title: "No access to permissions",
					description:
						"You don't have access to the permissions panel. Ask a superuser for the “Permissions panel” area.",
					back: "Back to admin panel",
				},
				unsavedModal: {
					title: "Unsaved changes",
					group:
						"You have unsaved changes in group {{name}}. If you continue without saving, they will be lost.",
					user: "You have unsaved changes for {{name}}. If you continue without saving, they will be lost.",
					discard: "Discard changes",
					back: "Back to editing",
					save: "Save and continue",
				},
				groups: {
					emptyTitle: "No group selected",
					emptyDescription:
						"Create the first group with “New group” and set its access levels per area.",
					search: "Search groups…",
					none: "There are no groups yet.",
					areasCount_one: "{{count}} area",
					areasCount_other: "{{count}} areas",
					membersCount_one: "{{count}} person",
					membersCount_other: "{{count}} people",
				},
				group: {
					levels: "Access level per area",
					writeIncludesRead:
						"Write includes read · add other areas with “Add area”",
					saveHint:
						"Saving replaces the group's permissions; Django codes are kept",
					saved: "Group saved.",
					delete: "Delete group",
					deleteTitle: "Delete group {{name}}?",
					deleted: "Group deleted.",
					deleteWarning_one:
						"Its permissions will be removed and {{count}} person will lose access granted by this group. This can't be undone.",
					deleteWarning_other:
						"Its permissions will be removed and {{count}} people will lose access granted by this group. This can't be undone.",
				},
				newGroup: {
					title: "New group",
					name: "Group name",
					submit: "Create group",
					exists: "A group with this name already exists.",
				},
				members: {
					picked: "Selected",
					pickedCount_one: "{{count}} person selected",
					pickedCount_other: "{{count}} people selected",
					title: "Group members",
					add: "Add user",
					remove: "Remove from group",
					already: "already in group",
					empty: "Nobody is in this group",
					emptyHint:
						"Add staff members – a group only works for people with panel access.",
					staffOnly: "Staff only – groups won't work without it.",
					notStaff: "Only staff members can be added to a group.",
				},
				areas: {
					title: "Areas",
					description:
						"An area is a pair of codes: view_ (read) and change_ (write). Add custom areas here; models of the old Django panel are included automatically.",
					area: "Area",
					codes: "Codes",
					usedIn: "Used in groups",
					unused: "unused",
					none: "There are no areas yet.",
					empty: "There are no areas yet. Add them in the Permissions tab.",
					codesHint: "{{read}} → read, {{write}} → write",
					custom: "custom",
					remove: "Remove area",
					removeHint: "× removes the area (level “None”)",
					noneAssigned: "No areas assigned.",
				},
				addArea: {
					title: "Add area",
					label: "Display name",
					key: "Area key",
					keyFormat: "Only lowercase a–z, digits and _",
					codes: "2 codes will be created:",
					submit: "Create area",
					exists: "An area with this key already exists.",
				},
				users: {
					actions: "Actions",
					sourceGroup: "group",
					sourceDirect: "permission",
					emptyTitle: "No person selected",
					emptyDescription:
						"Pick a person from the list to see and change their groups.",
					staffOnly: "staff only",
					search: "Search by name or e-mail…",
					noResults: "No results for “{{search}}”",
					noResultsHint:
						"We only search staff members. Add another account with “Add to staff”.",
					badge: {
						staff: "Staff",
						superuser: "Superuser",
						inactive: "Inactive",
					},
					superuser: "Superuser – full access to all areas",
					superuserNote: "Groups don't matter for this account.",
					inactive:
						"Inactive account – the user has no permissions, not even from groups.",
					noAreas: "no areas",
					effective: "Effective permissions",
					preview: "preview after saving",
					level: "Level",
					source: "Source",
					changed: "changed",
					fromGroups_one: "from group: {{groups}}",
					fromGroups_other: "from groups: {{groups}}",
					direct: "directly",
					directTitle: "Other permissions granted directly (Django)",
					directNote:
						"Codes outside areas. Same list as “User permissions” in Django admin – changes show up there immediately.",
					saveHint: "Saving covers groups and directly granted permissions",
					save: "Save groups",
					saved: "Changes saved.",
					saveFailed: "Could not save changes",
					saveFailedDetails:
						"The server responded {{status}}. Your changes are still in the form.",
					noGroups: "There are no groups yet.",
					goToGroups: "Go to the Groups tab",
					noAreasDefined: "No areas defined.",
					goToAreas: "Go to the Permissions tab",
					noAccess: "No access to any area.",
					changeInGroup: "change in group",
					directHint:
						"Grants permission directly on the account (like “User permissions” in Django). × removes.",
					editable: "editable",
					effectiveHint: "from groups and granted directly",
				},
			},
			section: {
				deniedTitle: "No access to this section",
				deniedDescription:
					"Ask someone with access to the permissions panel to grant you this part of the admin panel.",
			},
			accessDenied: {
				title: "Access denied",
				description: "This account has no access to the admin panel.",
				logout: "Log out",
			},
			notFound: {
				title: "Page not found",
				back: "Back to home",
			},
		},
	},
};

export { en };
